var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cookie-law", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(props) {
          return _c("div", { staticClass: "container" }, [
            _c(
              "div",
              {
                staticClass: "message",
                attrs: { slot: "message" },
                slot: "message"
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translation.footer.cookie) +
                    "\n      "
                ),
                _c("a", { attrs: { href: _vm.page } }, [
                  _vm._v(_vm._s(_vm.translation.blog.read_more))
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "buttons" }, [
              _c(
                "button",
                {
                  staticClass: "skew",
                  attrs: { id: "accept" },
                  on: { click: props.accept }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.translation.footer.accept_cookies))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "skew",
                  attrs: { id: "ignore" },
                  on: { click: props.close }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.translation.footer.ignore_cookies))
                  ])
                ]
              )
            ])
          ])
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }